import { render, staticRenderFns } from "./classeumDetailList.vue?vue&type=template&id=634c9a7b&"
import script from "./classeumDetailList.vue?vue&type=script&lang=js&"
export * from "./classeumDetailList.vue?vue&type=script&lang=js&"
import style0 from "./classeumDetailList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports